import { render, staticRenderFns } from "./EndDialog.vue?vue&type=template&id=76e5ad56"
import script from "./EndDialog.vue?vue&type=script&lang=js"
export * from "./EndDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports